<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" class="Icon--loading" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/loading.svg?raw'
export default {
  name: 'IconLoading',
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
